
import { Planet } from "../entities/planet.js";
import { Satellite } from "../entities/satellite";
import { Star } from "../entities/star";
import { Comet } from "../entities/comet.js";
import { BlackHole } from "../entities/blackHole.js";
import { WhiteHole } from "../entities/whiteHole.js";
import { Neutron } from "../entities/neutronStar.js";

import { normalizeAlphabetic } from "../helpers.js";


import { celestialData } from "./bodiesConfig.js";

const classMap = {
  blackhole: BlackHole,
  whitehole: WhiteHole,
  star: Star,
  neutron: Neutron,
  planet: Planet,
  satellite: Satellite,
  comet: Comet,
};

const argBuilders = {
  blackhole: ({ size, label }) => [size, label],
  whitehole: ({ size, label, pos }) => [size, label, pos],
  star: (node, parent) => [
    node.size,
    node.orbitRadius,
    node.axialTilt,
    node.orbitInclin,
    node.speedTrans,
    node.speedRot,
    node.eccentricity,
    node.name,
    parent,
  ],
  neutron: (node, parent) => [
    node.size,
    node.orbitRadius,
    node.axialTilt,
    node.orbitInclin,
    node.speedTrans,
    node.speedRot,
    node.eccentricity,
    node.label,
    parent,
  ],
  planet: (node, parent) => [
    node.size,
    node.texture || null,
    node.orbitRadius,
    node.axialTilt,
    node.orbitInclin,
    node.speedTrans,
    node.speedRot,
    node.eccentricity,
    node.argPeriapsis || 0,
    node.longAscNode || 0,
    node.label,
    parent,
    node.ring || null,
  ],
  satellite: (node, parent) => [
    node.size,
    node.texture || null,
    node.orbitRadius,
    node.axialTilt,
    node.orbitInclin,
    node.speedTrans,
    node.speedRot,
    node.eccentricity,
    node.argPeriapsis || 0,
    node.longAscNode || 0,
    node.label,
    parent,
  ],
  comet: (node, parent) => [
    node.size,
    null,
    node.orbitRadius,
    node.axialTilt,
    node.orbitInclin,
    node.speedTrans,
    node.speedRot,
    node.eccentricity,
    node.argPeriapsis || 0,
    node.longAscNode || 0,
    node.label,
    parent,
  ],
};

function buildArgs(node, parent) {
  const builder = argBuilders[node.type];
  if (!builder) {
    throw new Error(`Unknown type: ${node.type}`);
  }
  return builder(node, parent);
}

export function instantiateBodies() {
  const queue = [];
  const bodies = {};

  queue.push({ node: { ...celestialData.blackhole, type: 'blackhole' }, parent: null });
  queue.push({ node: { ...celestialData.whitehole, type: 'whitehole' }, parent: null });

  let level = 0;
  while (queue.length) {
    const levelSize = queue.length;

    for (let i = 0; i < levelSize; i++) {
      const { node, parent } = queue.shift();
      const Cls = classMap[node.type];
      const args = buildArgs(node, parent);
      const instance = new Cls(...args);

      let key;
      if (node.type === 'blackhole') {
        key = 'sagittariusa';
      } else if (node.type === 'whitehole') {
        key = 'whitehole';
      } else {
        const raw = node.label || node.name || node.type;

        key = normalizeAlphabetic(raw)
      }
      bodies[key] = instance;

      if (node.children) {
        Object.values(node.children).forEach(child =>
          queue.push({ node: { ...child, type: child.type }, parent: instance })
        );
      }
    }
    level++;
  }

  return bodies;
}


